import GPIProperties from './GPIProperties';
import GPIConditionalLogic from './GPIConditionalLogic';
import { initCheckboxHandler } from './GPICheckboxHandler';

window.GPIProperties = GPIProperties;
window.GPIConditionalLogic = GPIConditionalLogic;

// Initialize the event listener for checkbox handling.
// Tackles the issue of disabled checkboxes being selected/deselected.
initCheckboxHandler();
